// Root reducer for payment methods
export const PAYMENT_METHODS_REDUCER_NAME = 'paymentMethods'

export const SELECTED_PAYMENT_METHOD_REDUCER_NAME = 'selectedPaymentMethod'
export const PAYMENT_METHODS_LIST_REDUCER_NAME = 'paymentMethodsList'
export const PM_DEFAULT_REQUEST_REDUCER_NAME = 'pmDefaultRequest' // pm - payment method
export const DEFAULT_PAYMENT_METHODS_REDUCER_NAME = 'defaultPaymentMethods'
// TODO: IT'S DETACH_PAYMENT_METHOD (SINGLE)
export const DETACH_PAYMENT_METHODS_REDUCER_NAME = 'detachPaymentMethods'
